__turbopack_context__.v({
  "specBackground": "styles-module__UZFE9a__specBackground",
  "specItem": "styles-module__UZFE9a__specItem",
  "specList": "styles-module__UZFE9a__specList",
  "specValueLine": "styles-module__UZFE9a__specValueLine",
});
